package model

import org.w3c.xhr.XMLHttpRequest
import utils.*
import utils.ff.Companion.ffPegaCampo
import utils.ff.Companion.println0

open class Fatloteitem {
    var FATITE_EMPRESA = 0
    var FATITE_LOTE = 0
    var FATITE_PRODUTO = 0
    var FATITE_QTDE = 0.0
    var FATITE_QTCONT = 0.0
    var ESTG_UNIDVENDA = 0.0
    var ESTG_EAN = ""
    var ESTG_TIPO = ""

    var ESTG_EAN1 = ""
    var ESTG_EAN2 = ""
    var ESTG_EAN3 = ""

    var PRO_CXEMBARQUE = ""
    var OO_DESCRCOMPLETA = ""
    var OO_PRODUTO = ""
    var OO_QTDFALTA = 0.0
    var OO_UNIDVENDA = 0.0
    //var OO_FALTASN = ""
    var OO_TIPO = ""
    var OO_DATACONT = ff.InicialDate

//    fun construtor(EMPRESA: Int, LOTE: Int, PRODUTO: Int,
//                   QTDE: Double, QTCONT: Double,
//                   UNIDVENDA: Double, EAN: String,
//                   CXEMBARQUE: String, DESCRCOMPLETA: String): Fatloteitem {
//        this.FATITE_EMPRESA = EMPRESA
//        this.FATITE_LOTE = LOTE
//        this.FATITE_PRODUTO = PRODUTO
//        this.FATITE_QTDE = QTDE?: 0.0
//        this.FATITE_QTCONT = QTCONT?: 0.0
//        this.ESTG_UNIDVENDA = UNIDVENDA
//        this.ESTG_EAN = EAN
//        this.PRO_CXEMBARQUE = CXEMBARQUE
//        this.PRO_DESCRCOMPLETA = DESCRCOMPLETA
//        return this
//    }

    fun construtorLista(it: String): List<Fatloteitem> {

        var iLinha = 0
        val lObj = ArrayList<Fatloteitem>()
        //ff.println0("zuza aqui")
        //ff.println0(it.responseText.toString())

        if (!it.equals(null) && !it.equals("")) {
            val lista = JSON.parse<Array<dynamic>>(it)
            lista.forEach {
                val o = Fatloteitem()
                o.FATITE_EMPRESA = it.FATITE_EMPRESA.toString().ffVsi()
                o.FATITE_LOTE = it.FATITE_LOTE.toString().ffVsi()
                o.FATITE_PRODUTO = it.FATITE_PRODUTO.toString().ffVsi()
                o.FATITE_QTDE = it.FATITE_QTDE.toString().ffVsdo()
                o.FATITE_QTCONT = it.FATITE_QTCONT.toString().ffVsdo()
                o.ESTG_UNIDVENDA = it.ESTG_UNIDVENDA.toString().ffVsdo()
                o.ESTG_EAN = it.ESTG_EAN.toString().ffVss()
                o.ESTG_EAN1 = it.ESTG_EAN1.toString().ffVss()
                o.ESTG_EAN2 = it.ESTG_EAN2.toString().ffVss()
                o.ESTG_EAN3 = it.ESTG_EAN3.toString().ffVss()
                o.ESTG_TIPO = it.ESTG_TIPO.toString().ffVss()
                o.PRO_CXEMBARQUE = it.PRO_CXEMBARQUE.toString().ffVss()
                o.OO_DESCRCOMPLETA = it.OO_DESCRCOMPLETA.toString().ffVss()

                o.OO_PRODUTO = o.FATITE_PRODUTO.ffZeroLeft(6) + " - " + o.OO_DESCRCOMPLETA
                /*
                o.OO_QTDFALTA = o.FATITE_QTDE - o.FATITE_QTCONT

                if (o.OO_QTDFALTA == 0.0)
                    o.OO_FALTASN = ""
                else if (o.OO_QTDFALTA < 0)
                    o.OO_FALTASN = "sobra"
                else
                    o.OO_FALTASN = "falta"

                 */


                lObj.add(o)
            }
        }
        return lObj
    }

    fun getFatloteItens(iCodigo: String, cb: (List<Fatloteitem>) -> Unit) {

        ff.println0("executando getFatloteItens")
        Service().getString("fatlote/012/${ff.giEmpresa}/$iCodigo") { _sRetorno ->
            //println0("zuza aqui = $_sRetorno")
            val lista = construtorLista(_sRetorno)
            for (o in lista) {
                o.OO_QTDFALTA = o.FATITE_QTDE - o.FATITE_QTCONT
            }
            /*
            for (o in lista) {
                o.OO_QTDFALTA = o.FATITE_QTDE - o.FATITE_QTCONT
                if (o.OO_QTDFALTA == 0.0)
                    o.OO_FALTASN = ""
                else if (o.OO_QTDFALTA < 0)
                    o.OO_FALTASN = "sobra"
                else
                    o.OO_FALTASN = "falta"
            }

             */
            cb(lista)
        }
    }

    fun getFatProduto(_produto: String, _lote: String, cb: (List<Fatloteitem>) -> Unit) {

        ff.println0("executando getFatProduto")
        Service().getString("fatlote/013/${ff.giEmpresa}/$_lote/$_produto") { _sRetorno ->
            //println0("zuza aqui = $_sRetorno")
            //http://dlogica.ddns.net:8080/AdmRetGD/res/fatlote/013/1/10948/11420/token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjbGllbnRlIjoxMTI3LCJlbXBDbGllbnRlIjoxMTI3LCJ2YXJpYXZlbCI6IiIsImNvbnRhdG8iOjAsInRpcG9TZWd1cmFuY2EiOiJmdW4iLCJlbWFpbCI6ImVzdG9xdWVAZ3JhbmFkb2Rpc3RyaWJ1aWRvcmEuY29tLmJyIiwiYWRtaW4iOmZhbHNlLCJleHBpcmFjYW8iOiIyMDIyLTExLTEwIiwiZW1wU2VyaWUiOiIyMiIsImVtcHJlc2EiOiIxIiwiY2hhdmUiOiIifQ==.0gEu4L+1tNMpnw6Tkvyr1RY+YzJ/QRIrOjBr4VvxyJg=
            cb(construtorLista(_sRetorno))
        }
    }

    fun reg(_produto: String, _llote: List<Fatloteitem>): Fatloteitem? {

        var obj: Fatloteitem? = null
        obj = _llote.filter({ p -> p.FATITE_PRODUTO.toString().equals(_produto) }).getOrNull(0)
        if (obj != null) {
            obj!!.OO_UNIDVENDA = obj!!.ESTG_UNIDVENDA
            obj!!.OO_TIPO = obj!!.ESTG_TIPO
        }

        if (obj == null) {
            obj = _llote.filter({ p -> p.ESTG_EAN1.contains("|EAN=$_produto") }).getOrNull(0)
            if (obj != null) {
                obj!!.OO_UNIDVENDA = obj!!.ESTG_EAN1.ffPegaCampo("|UNIDVENDA=").ffVsc()
                obj!!.OO_TIPO = obj!!.ESTG_EAN1.ffPegaCampo("|TIPO=")
            }
        }
        if (obj == null) {
            obj = _llote.filter({ p -> p.ESTG_EAN2.contains("|EAN=$_produto") }).getOrNull(0)
            if (obj != null) {
                obj!!.OO_UNIDVENDA = obj!!.ESTG_EAN2.ffPegaCampo("|UNIDVENDA=").ffVsc()
                obj!!.OO_TIPO = obj!!.ESTG_EAN2.ffPegaCampo("|TIPO=")
            }
        }
        if (obj == null) {
            obj = _llote.filter({ p -> p.ESTG_EAN3.contains("|EAN=$_produto") }).getOrNull(0)
            if (obj != null) {
                obj!!.OO_UNIDVENDA = obj!!.ESTG_EAN3.ffPegaCampo("|UNIDVENDA=").ffVsc()
                obj!!.OO_TIPO = obj!!.ESTG_EAN3.ffPegaCampo("|TIPO=")
            }
        }
        if (obj != null && obj!!.OO_UNIDVENDA == 0.0)
            obj!!.OO_UNIDVENDA = 1.0
        return obj
    }

    fun countMax(lista: List<Fatloteitem>?): List<Fatloteitem> {

        val l2 = ArrayList<Fatloteitem>()
        if (lista != null) {
            val l1 = lista!!.filter({ p -> p.FATITE_QTDE != p.FATITE_QTCONT }).sortedByDescending{ it.OO_DATACONT.compareNow() }
            //var l1 = lista!!.filter({ p -> p.FATITE_QTDE != p.FATITE_QTCONT }).sortedByDescending ({ f1 -> (f1.OO_DATACONT.compare(f1.OO_DATACONT)) })
            //.sortedBy( { f1 -> (f1.FATITE_QTDE).compareTo(f1.FATITE_QTDE) } )
            //l1 = l1.sortedBy({ f1 -> (f1.OO_DATACONT.compare(f1.OO_DATACONT)) })
            //println0(l1)
            //val l1 = llote!!.filter({ p -> p.FATITE_QTDE != p.FATITE_QTCONT }).toList().sortedBy({ f1, f2 -> (f1.OO_DATACONT.compare(f2.OO_DATACONT)) }).toList()
            var iCont = 0
            for (o in l1) {
                l2.add(o)
                iCont += 1
                if (iCont > 50)
                    break
            }
        }
        return l2
    }

}